var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9487 16.3912V18.2708C24.9487 19.8557 23.4704 21.1409 21.6467 21.1409C19.823 21.1409 18.3447 19.8557 18.3447 18.2708V16.3912C18.3447 17.9761 19.823 19.109 21.6467 19.109C23.4704 19.109 24.9487 17.9761 24.9487 16.3912Z",
    stroke: "#1062D0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9487 13.8512C24.9487 14.3134 24.8217 14.7402 24.5982 15.1059C24.0546 16 22.937 16.569 21.6467 16.569C20.3564 16.569 19.2388 16 18.6952 15.1059C18.4717 14.7402 18.3447 14.3134 18.3447 13.8512C18.3447 13.0587 18.7156 12.3424 19.3099 11.8243C19.9094 11.301 20.7323 10.981 21.6467 10.981C22.5611 10.981 23.3841 11.301 23.9835 11.8192C24.5779 12.3424 24.9487 13.0587 24.9487 13.8512Z",
    stroke: "#1062D0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9487 13.8512V16.3912C24.9487 17.9761 23.4704 19.109 21.6467 19.109C19.823 19.109 18.3447 17.9761 18.3447 16.3912V13.8512C18.3447 12.2662 19.823 10.981 21.6467 10.981C22.5611 10.981 23.3841 11.301 23.9835 11.8192C24.5779 12.3424 24.9487 13.0587 24.9487 13.8512Z",
    stroke: "#1062D0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5972 8.3683C21.5972 4.73658 19.5219 3.18014 16.409 3.18014H6.03268C2.91979 3.18014 0.844523 4.73658 0.844523 8.3683V15.6317C0.844523 19.2634 2.91979 20.8199 6.03268 20.8199H16.409",
    stroke: "#1062D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46364 8.56787L9.30349 10.8361C10.238 11.5801 11.7713 11.5801 12.7059 10.8361L15.5366 8.56787",
    stroke: "#1062D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsBlue);
export default __webpack_public_path__ + "static/media/sms-blue.321bbf0c65029c6ab64853a1ccb030ee.svg";
export { ForwardRef as ReactComponent };